import { GoogleAuthRedirect } from "#webapp/src/auth/GoogleAuthRedirect";
import { MicrosoftAuthRedirect } from "#webapp/src/auth/MicrosoftAuthRedirect";
import { AsanaAuth } from "#webapp/src/components/asana-auth";
import { AsanaTask } from "#webapp/src/components/asana-task";
import { AsanaWrapper, asanaWrapperQuery } from "#webapp/src/components/asana-wrapper";
import { BrowserNotificationPermissionBanner } from "#webapp/src/components/browser-notification-permission-banner";
import { ChromeSlackWrapperPage } from "#webapp/src/components/chrome-slack-wrapper";
import { ChromeZoomVerifierPage } from "#webapp/src/components/chrome-zoom-verifier";
import { HomeUninstall } from "#webapp/src/components/home-uninstall";
import { HomeWrapper } from "#webapp/src/components/home-wrapper";
import { LinksWelcome } from "#webapp/src/components/links-welcome";
import { LoginWrapperPage } from "#webapp/src/components/login-wrapper";
import { ModernWrapperPage } from "#webapp/src/components/modern-wrapper";
import { NonUserDefragSurveyPage } from "#webapp/src/components/non-user-defrag-survey";
import { SudoWrapperPage } from "#webapp/src/components/sudo-wrapper";
import { UnsubscribeWrapperPage } from "#webapp/src/components/unsubscribe-wrapper";
import { WebAppCheckoutPage } from "#webapp/src/components/web-app-checkout";
import { WebAppPricingPage } from "#webapp/src/components/web-app-pricing";
import { WebAppRedirect } from "#webapp/src/components/web-app-redirect";
import { WebAppSlack, webAppSlackQuery } from "#webapp/src/components/web-app-slack";
import { WebAppWrapperPage } from "#webapp/src/components/web-app-wrapper";
import { experiments } from "#webapp/src/state/local-storage";
import {
  requireApp,
  requireAppSharedProposal,
  requireAppWelcomeAmbiguous,
  requireLoginOutlook,
  requireLogout,
  requireNoAuthApp,
  requireSudo,
} from "#webapp/src/util/auth.util";
import { outlookPaths, paths } from "@clockwise/client-commons/src/constants/site";
import { Null } from "@clockwise/web-commons/src/components/null";
import {
  appPaths,
  pagePaths,
  webappPathRoot,
} from "@clockwise/web-commons/src/constants/route.constants";
import { isElectron } from "@clockwise/web-commons/src/util/browser.util";
import { isInIframe } from "@clockwise/web-commons/src/util/react.util";
import { Redirect, Route, makeRouteConfig } from "found";
import * as React from "react";
import { ClockwiseMini } from "../components/clockwise-mini/ClockwiseMini";
import { RootMini } from "../components/clockwise-mini/RootMini";
import TeamCreateOrJoinPage from "../components/team-settings/TeamCreateOrJoinPage";
import TeamSettingsPage from "../components/team-settings/TeamSettingsPage";
import { WebOnboarding } from "../components/web-app/WebOnboarding";
import WebLayout from "../components/web-layout/WebLayout";
import { WebNavigation } from "../components/web-navigation/WebNavigation";
import { WebSettingsExperiments } from "../components/web-settings/web-settings-experiments";
import AIPage from "../pages/AIPage";
import AccountPreferencesPage from "../pages/AccountPreferencesPage";
import AccountSettingsPage from "../pages/AccountSettingsPage";
import AdminAnalyticsPage from "../pages/AdminAnalyticsPage";
import AppSettingsPage from "../pages/AppSettingsPage";
import FlexibleHoldsPage from "../pages/FlexibleHoldsPage";
import FlexibleMeetingsPage from "../pages/FlexibleMeetingsPage";
import { GatewayGraphiQLPage } from "../pages/GatewayGraphiQLPage";
import GatewayTestPage from "../pages/GatewayTestPage";
import { LinkBookingPage } from "../pages/LinkBookingPage";
import { LinkCancelPage } from "../pages/LinkCancelPage";
import { LinkReschedulePage } from "../pages/LinkReschedulePage";
import OrganizationMembersPage from "../pages/OrganizationMembersPage";
import OrganizationSettingsPage from "../pages/OrganizationSettingsPage";
import PlannerPage from "../pages/PlannerPage";
import PlansAndBillingPage from "../pages/PlansAndBillingPage";
import ProposalPage from "../pages/ProposalPage";
import { PublicSharedProposalPage } from "../pages/PublicSharedProposalPage";
import SchedulingLinksPage from "../pages/SchedulingLinksPage";
import { SetupSchedulingLinkPage } from "../pages/SetupSchedulingLinkPage";
import TeamsSettingPage from "../pages/TeamsSettingsPage";
import WebLandingPage from "../pages/WebLandingPage";
import {
  componentOrRedirectByCondition,
  getComponentOrRedirect,
  noopComponent,
  requireAuthForCalendarView,
  requireExtensionStoreRedirect,
  requireInviteAttributionAndRedirect,
  withRouteQuery,
} from "./routes.util";

//////////////////
// ROUTE CONFIG
//////////////////
const subRootRoutes = (
  <>
    <Route Component={HomeWrapper}>
      <Route
        path={`${paths.redirect}`}
        getComponent={(props) => getComponentOrRedirect(WebAppRedirect, requireNoAuthApp, props)}
      />
      <Route
        path={`${paths.slackLanding}/:step?`}
        Component={withRouteQuery(WebAppSlack, webAppSlackQuery)}
      />
      <Route path={paths.uninstall} Component={HomeUninstall} />
      <Route
        path={`${paths.nonUserDefragSurvey}/:emailInstanceId`}
        Component={NonUserDefragSurveyPage}
      />
      <Route path={`${paths.unsubscribe}/:email/:token`} Component={UnsubscribeWrapperPage} />
      <Route
        path={`${paths.login}/:redirect?`}
        getComponent={(props) => getComponentOrRedirect(LoginWrapperPage, requireNoAuthApp, props)}
      />
      <Route
        path={`${paths.signup}/:redirect?`}
        getComponent={(props) => getComponentOrRedirect(LoginWrapperPage, requireNoAuthApp, props)}
        render={({ Component, props }) => {
          return Component ? <Component {...props} variant="invite" /> : null;
        }}
      />
      <Route
        path={`${paths.welcomeSignIn}/:redirect?`}
        getComponent={(props) => getComponentOrRedirect(LoginWrapperPage, requireNoAuthApp, props)}
        render={({ Component, props }) => {
          return Component ? <Component {...props} variant="welcome-ambiguous" /> : null;
        }}
      />
      <Route
        path={`${paths.welcome}/:redirect?`}
        getComponent={(props) => getComponentOrRedirect(LoginWrapperPage, requireNoAuthApp, props)}
        render={({ Component, props }) => {
          return Component ? <Component {...props} variant="welcome" /> : null;
        }}
      />
      <Route
        path={`${paths.m365SignIn}/:redirect?`}
        getComponent={(props) => getComponentOrRedirect(LoginWrapperPage, requireNoAuthApp, props)}
        render={({ Component, props }) => {
          return Component ? <Component {...props} variant="m365" /> : null;
        }}
      />
      <Route
        path={`${paths.linksOnboardingLogin}`}
        getComponent={(props) => getComponentOrRedirect(LinksWelcome, requireNoAuthApp, props)}
      />
    </Route>
    <Route
      path={paths.webApp}
      getComponent={(props) => getComponentOrRedirect(WebAppWrapperPage, requireApp, props)}
    >
      <Route
        path={pagePaths.onboarding}
        getComponent={(props) => getComponentOrRedirect(WebOnboarding, requireApp, props)}
      />
      <Route
        path={`${paths.pricing}/:teamId?`}
        getComponent={(props) => getComponentOrRedirect(WebAppPricingPage, requireApp, props)}
      />
      <Route
        path={`${paths.checkout}/:teamId?`}
        getComponent={(props) => getComponentOrRedirect(WebAppCheckoutPage, requireApp, props)}
      />
    </Route>
    <Route
      path={paths.logout}
      getComponent={(props) => getComponentOrRedirect(noopComponent, requireLogout, props)}
    />
    <Route
      path={paths.signout}
      getComponent={(props) => getComponentOrRedirect(noopComponent, requireLogout, props)}
    />
    <Route
      path={paths.sudo}
      getComponent={(props) => getComponentOrRedirect(SudoWrapperPage, requireSudo, props)}
    />

    <Route path={`${paths.chromeZoomVerifier}/account`} Component={ChromeZoomVerifierPage} />

    <Route path={`${paths.chromeZoomVerifier}/user`} Component={ChromeZoomVerifierPage} />

    <Route path={paths.chromeSlackVerifier} Component={ChromeSlackWrapperPage} />

    <Route path={`${paths.chromeSlackVerifier}/team/:teamId`} Component={ChromeSlackWrapperPage} />

    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireApp, props)}
      data={{ withToolbar: true }}
    >
      <Route path={pagePaths.landing}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={WebLandingPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.testPage}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={GatewayTestPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.accountPreferences}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={AccountPreferencesPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.flexibleMeetings}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={FlexibleMeetingsPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.flexibleHolds}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={FlexibleHoldsPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.schedulingLinks}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: (
            <Route
              path="/"
              getComponent={(props) =>
                componentOrRedirectByCondition(
                  SchedulingLinksPage,
                  isInIframe() || isElectron,
                  "/app" + paths.mini,
                  props,
                )
              }
            />
          ),
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.appSettings}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={AppSettingsPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={`${pagePaths.teamSettings}/:teamId`}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={TeamSettingsPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.teamsSettings}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={TeamsSettingPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.createOrJoinTeam}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={TeamCreateOrJoinPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path={pagePaths.analytics}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={AdminAnalyticsPage} />,
        }}
      </Route>
      <Route path={`${pagePaths.members}/:billingGroupId?`}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={OrganizationMembersPage} />,
        }}
      </Route>
      <Route path={pagePaths.plansAndBilling}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlansAndBillingPage} />,
        }}
      </Route>
      <Route path={pagePaths.orgSettings}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={OrganizationSettingsPage} />,
        }}
      </Route>
      <Route path={pagePaths.preferences}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={AccountSettingsPage} />,
        }}
      </Route>
      <Route path={pagePaths.experiments}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={WebSettingsExperiments} />,
        }}
      </Route>
      <Route path={pagePaths.graphiql}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={GatewayGraphiQLPage} />,
        }}
      </Route>
    </Route>
    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireApp, props)}
      data={{ withToolbar: false, collapsedSidebar: true }}
    >
      <Route path={pagePaths.ai} data={{ collapsedSidebar: true }}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={AIPage} />,
        }}
      </Route>
    </Route>
    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireAppSharedProposal, props)}
      data={{ withToolbar: false, collapsedSidebar: true }}
    >
      <Route path={`${pagePaths.proposal}/:proposalId`} data={{ collapsedSidebar: true }}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={ProposalPage} />,
        }}
      </Route>
    </Route>
    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireApp, props)}
      data={{ withToolbar: false }}
    >
      <Route path={pagePaths.planner}>
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path="/team-analytics">
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/autopilot-list">
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/calendar-profile/:calendarId/:viewWeek?">
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/event/:encodedExternalEventId/:encodedCalendarId/:fullView?">
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path="/event/:encodedExternalEventId/:fullView?">
        {{
          secondary: <Route path="(.*)?" Component={WebNavigation} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Redirect from="/members" to={appPaths.members} />
    </Route>
    <Redirect from="/canary/(.*)?" to={appPaths.landing} />
    <Redirect from="/app/admin" to={appPaths.analytics} />
    <Redirect from="/app/admin/members/(.*)?" to={appPaths.members} />
    <Redirect from="/app/admin/billing" to={appPaths.plansAndBilling} />
    <Redirect from="/app/admin/settings" to={appPaths.orgSettings} />
    <Redirect from={paths.calendar} to={appPaths.planner} />
    <Redirect from="/app/chat" to={appPaths.ai} />
    <Redirect from={paths.oneOnOnes} to={`${appPaths.flexibleMeetings}`} />
    <Redirect
      from={`/app${paths.webSettings}/account/smart-holds/*`}
      to={`${appPaths.accountPreferences}`}
    />
    <Redirect from={`/app${paths.webSettings}/account/*`} to={`${appPaths.preferences}`} />
    <Redirect
      from={`/app${paths.webSettings}/teams/create-or-join-team`}
      to={`${appPaths.createOrJoinTeam}`}
    />
    <Redirect from={`/app${paths.webSettings}/teams/*`} to={`${appPaths.teamsSettings}`} />
    <Redirect
      from={`/app${paths.webSettings}/:path1?/:path2?/:path3?/:path4?`}
      to={`${appPaths.landing}`}
    />
    <Redirect from="/app/settings/(.*)?" to={appPaths.preferences} />
    <Redirect from={appPaths.aiScheduler} to={appPaths.ai} />

    <Route path={paths.asana} Component={withRouteQuery(AsanaWrapper, asanaWrapperQuery)}>
      <Route
        getComponent={(props) =>
          getComponentOrRedirect(AsanaAuth, requireAppWelcomeAmbiguous, props)
        }
      />
      <Route
        path={`task/:calendar_id/:event_id`}
        getComponent={(props) =>
          getComponentOrRedirect(AsanaTask, requireAppWelcomeAmbiguous, props)
        }
      />
    </Route>

    <Route
      path={"/app" + paths.mini}
      getComponent={(props) => {
        return getComponentOrRedirect(
          RootMini,
          requireAppWelcomeAmbiguous,
          props,
          experiments.getFlag("DebugMini") ? false : isInIframe(),
        );
      }}
    />
  </>
);

export const schedulingLinkRoutes = (
  <>
    {/* Public Scheduling Link routes */}
    <Route path={paths.schedulingLink} Component={LinkBookingPage} />
    <Route path={paths.cancelBooking} Component={LinkCancelPage} />
    <Route path={paths.rescheduleBooking} Component={LinkReschedulePage} />

    {/* Authenticated Scheduling Link routes */}
    <Route
      path={paths.createSchedulingLink}
      getComponent={(props) => getComponentOrRedirect(SetupSchedulingLinkPage, requireApp, props)}
    />
    <Route
      path={paths.editSchedulingLink}
      getComponent={(props) => getComponentOrRedirect(SetupSchedulingLinkPage, requireApp, props)}
    />
    <Route
      path={paths.schedulingLinksCompact}
      getComponent={(props) =>
        getComponentOrRedirect(ClockwiseMini, requireAppWelcomeAmbiguous, props, isInIframe())
      }
    />
    <Route
      path={outlookPaths.schedulingLinksCompact}
      getComponent={(props) => getComponentOrRedirect(ClockwiseMini, requireLoginOutlook, props)}
    />
  </>
);

export const routeConfig = makeRouteConfig(
  <>
    <Route path="/" Component={ModernWrapperPage}>
      {subRootRoutes}
      {schedulingLinkRoutes}
      <Route path={paths.sharedProposal} Component={PublicSharedProposalPage} />
    </Route>
    <Route path="/test-:mainBranch" Component={ModernWrapperPage}>
      {subRootRoutes}
      {schedulingLinkRoutes}
    </Route>

    {/* Routes that don't need the top-level ModernWrapperQuery run*/}
    <Route path={paths.microsoftAuthRedirect} Component={MicrosoftAuthRedirect} />
    <Route path={paths.googleAuthRedirect} Component={GoogleAuthRedirect} />

    {/* A/B signup expeirment route that will be used by marketing to test directing using to store or webapp on marketing site */}
    <Route
      path={paths.signupExtension}
      getComponent={(props) => requireExtensionStoreRedirect(props, Null, paths.signup, true)}
    />
    <Route
      path={`${paths.invite}/:inviteToken?`}
      getComponent={(props) => requireExtensionStoreRedirect(props, Null, paths.signup, false)}
    />
    <Route
      path={`${paths.personalInvite}/:inviteToken?`}
      getComponent={(props) => requireInviteAttributionAndRedirect(props, Null, paths.welcome)}
    />
    <Route
      path={paths.installExtension}
      getComponent={(props) => requireAuthForCalendarView(props, Null)}
    />
  </>,
);
